import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { prepareModifiersForClassNames } from "../../utils/bem";

function CheckBox({
  className,
  invalid,
  label,
  helpText,
  small,
  dataTestId,
  ...props
}) {
  const modifiers = {
    invalid,
    small,
  };

  return (
    <span
      className={classnames(
        "Checkbox",
        prepareModifiersForClassNames("Checkbox", modifiers),
        className,
      )}
      data-testid={dataTestId}
    >
      <label className="Checkbox-label">
        <span className="Checkbox-checkboxContainer">
          <input type="checkbox" {...props} className="Checkbox-checkbox" />
        </span>
        <span className="Checkbox-textContainer">
          <span className="Checkbox-labelText">{label}</span>
          {helpText && <span className="Checkbox-helpText">{helpText}</span>}
        </span>
      </label>
    </span>
  );
}

CheckBox.propTypes = {
  label: PropTypes.node,
  helpText: PropTypes.node,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  invalid: PropTypes.bool,
  small: PropTypes.bool,
  dataTestId: PropTypes.string,
};

export default CheckBox;
